module.exports = __webpack_public_path__ + "static/ywnrh-68395415524551dfce9ca47a7502b018.jpg";